import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faLock, faEye, faEyeSlash, faChevronLeft, faShareSquare } from '@fortawesome/free-solid-svg-icons'
import { faGooglePlusG, faFacebookF } from '@fortawesome/free-brands-svg-icons';

const withIcons = (Component) => {
    return class EnhancedComponent extends React.Component {
        state = {
            icons: {
                mail: <FontAwesomeIcon icon={faEnvelope} color='#67BAAF' />,
                lock: <FontAwesomeIcon icon={faLock} color='#67BAAF' />,
                eye: <FontAwesomeIcon icon={faEye} color='#67BAAF' />,
                eyeSlash: <FontAwesomeIcon icon={faEyeSlash} color='#67BAAF' />,
                google: <FontAwesomeIcon icon={faGooglePlusG} color='#ffffff' />,
                facebook: <FontAwesomeIcon icon={faFacebookF} color='#ffffff' />,
                chevronLeft: <FontAwesomeIcon icon={faChevronLeft} color='#000000' />,
                back: <FontAwesomeIcon icon={faChevronLeft} color='#000000' />,
                backwhite: <FontAwesomeIcon icon={faChevronLeft} color='#ffffff' />,
                secure: <FontAwesomeIcon icon={faLock} color='#67BAAF' />,
                eyeclose: <FontAwesomeIcon icon={faEyeSlash} color='#67BAAF' />,
                share: <FontAwesomeIcon icon={faShareSquare} color='#ffffff' />
            }
        }

        render() {
            return (
                <Component icons={this.state.icons} />
            )
        }
    };
};

export default withIcons;
